<template>
    <section class="add-point-bottom" :class="{'interactive-mode-without-discussion': isInteractive() && discussionModule != 1}">
        <img
            src="../../../../assets/icons/components/go-back-arrow.svg"
            class="add-point-bottom__go-back"
            v-if="isAddPointToParent"
            @click="this.$emit('cancelAddPointToParent')"
        />
        <form
            class="add-point-bottom__input-wrapper"
            v-error="{ errors, input_key: 'name' }"
            @submit="
                (e) => { 
                    e.preventDefault();
                    this.addPoint();
                }
            "
        >
            <input ref="autofocus"
                type="text"
                class="add-point-bottom__input"
                :placeholder="$t('com.file.add-point-bottom-menu.add-point-name-placeholder')"
                v-model="pointName" 
            />
            <button class="add-point-bottom__add-btn" type="submit">
                <img
                    src="../../../../assets/icons/panel/editSession/plus.svg"
                />
                <span class="add-point-bottom__btn-text">{{$t('com.file.add-point-bottom-menu.add-agenda-point')}}</span>
            </button>
        </form>
        <ErrorMessage
            v-if="isError('name', this.errors)"
            
        />
    </section>
</template>

<script charset="utf-8">
import ErrorMessage from "../../../BasicControls/ErrorMessage.vue";
 import { encryptStorage } from '@/services/encrypt.service';
import { passErrorMsg, isError, setErrors } from "../../../../formValidation/main";

export default {
    name: "AddPointBottomMenu",
    data() {
        return {
            pointName: "",
            errors: [],
            discussionModule: encryptStorage.getItem('modules').d,
        };
    },
    props: {
        session: Object,
        isAddPointToParent: Boolean,
    },
    components: {
        ErrorMessage,
    },
    computed:{
    },
    mounted() {
        if (this.isAddPointToParent)
            this.$refs.autofocus.focus();
    },
    methods: {
        isInteractive() {
            return this.$store.state.appStore.isInInteractiveMode;
        },
        validate(data) {
            var bo = true;
            var err = {};
            if (data.name.length <= 0) {
                err.name = [this.$t('com.global.required-field')]
                bo = false
            }

            if (!bo) {
                this.isLoading = false;
                this.errors = setErrors(err)
            }
            return bo
        },
        addPoint() {
            this.errors = [];
            const data = {
                name: this.pointName
            }

            if (this.validate(data) == false)
                return

            this.$emit("addPoint", this.pointName);
            this.pointName = "";
            this.errors = [];
        },
        passErrorMsg,
        isError,
        setErrors,
    },
};
</script>

<style lang="scss" scoped>
.add-point-bottom {
    position: fixed;
    bottom: 34px;
    right: 24px;
    width: calc(100% - 410px);
    z-index: 3;
    background-color: white;
    padding: 16px;
    border-radius: 12px;
    box-sizing: border-box;
    align-items: center;
    box-shadow: 0px 0px 24px rgba(76, 82, 107, 0.16);
    display: flex;
    align-items: center;

    @media only screen and (max-width: 1600px) {
        width: calc(100% - 310px);
    }

    &__input-wrapper {
        background: #f4f6fa;
        box-sizing: border-box;
        box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.08);
        border-radius: 4px;
        display: flex;
        width: 100%;
    }

    &__input {
        border: 0px;
        width: 100%;
        font-size: 16px;
        line-height: 144%;
        background: #f4f6fa;
        padding: 0px 24px;
        border: 1px solid #dde0e7;

        &:focus {
            border: 1px solid #00082c;
        }

        &::placeholder {
            font-size: 16px;
            line-height: 144%;
            color: #808396;
        }
    }

    &__add-btn {
        width: 234px;
        height: 48px;
        background: #d80418;
        border-radius: 0px 4px 4px 0px;
        border: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease-in-out;

        &:hover {
            background-color: #ad0313;
        }
    }

    &__buttons {
        display: flex;
        align-items: center;
    }

    &__button {
        width: 44px;
        height: 44px;
        background: #ffffff;
        border: 1px solid #bbc2ce;
        box-sizing: border-box;
        border-radius: 4px;
        margin-left: 8px;
    }

    &__btn-text {
        color: white;
        font-weight: 500;
        font-size: 16px;
        line-height: 132%;
        margin-left: 10.5px;
    }

    &__go-back {
        margin-right: 20px;
        cursor: pointer;
    }
}

.add-point-bottom.interactive-mode-without-discussion{
   width: calc(100% - 55px);
}
</style>
